import { useId } from "react";
import { ACCOUNTING_REPORT_COMPARISON_OPTIONS } from "@common/types/reports/report-type";
import { DescriptionListItem } from "@design-system/DescriptionList/DescriptionList";
import { AccountingReportComparisonSelect } from "@components/accounting/AccountingReportComparisonSelect";
import { AccountingReportCycleSelect } from "@components/accounting/AccountingReportCycleSelect";
import {
    REPORT_TYPE_BY_TASK_TYPE,
    ReportDisplayFilters,
    ReportDisplayFiltersPatch,
    ReportTaskType,
} from "./reportDisplayFilters";

interface Props {
    taskType: ReportTaskType;
    value: ReportDisplayFilters;
    onChange: (patch: ReportDisplayFiltersPatch) => void;
    wrapperClassName?: string;
    triggerClassName?: string;
}

export const ReportDisplayFields = ({
    taskType,
    value,
    onChange,
    wrapperClassName,
    triggerClassName,
}: Props) => {
    const groupingId = useId();
    const comparisonId = useId();

    return (
        <>
            <DescriptionListItem label="Grouping" htmlFor={groupingId}>
                <div className={wrapperClassName}>
                    <AccountingReportCycleSelect
                        id={groupingId}
                        value={value.cycle}
                        onChange={(cycle) => onChange({ cycle })}
                        className={triggerClassName}
                    />
                </div>
            </DescriptionListItem>
            <DescriptionListItem label="Comparison" htmlFor={comparisonId}>
                <div className={wrapperClassName}>
                    <AccountingReportComparisonSelect
                        id={comparisonId}
                        comparisons={value.comparisons}
                        comparisonDiffs={value.comparisonDiffs}
                        ratioTypes={value.ratioTypes}
                        availableOptions={
                            ACCOUNTING_REPORT_COMPARISON_OPTIONS[
                                REPORT_TYPE_BY_TASK_TYPE[taskType]
                            ]
                        }
                        onChange={onChange}
                        className={triggerClassName}
                    />
                </div>
            </DescriptionListItem>
        </>
    );
};
